import { configureStore } from "@reduxjs/toolkit";
import cancelRideReducer from "./features/cancelRideSlice";

export const store = configureStore({
    reducer: {
        cancelRide: cancelRideReducer,
    },
});